import { Anchor, GetProp, GetProps } from 'antd';
import classNames from 'classnames/bind';
import * as React from 'react';
import Styles from './assets/style.scss';
import { IAnchorProps, IAnchorsItem, IAnchorState } from './entities';

type AnchorLinkItems = GetProp<typeof Anchor, 'items'>[number];

const cx = classNames.bind(Styles);
export const Link = Anchor.Link;

const BCAnchor = (props: IAnchorProps) => {
	Styles;
	const [didClickedScroll, setDidClickedScroll] = React.useState(false);

	const onClick = (e: React.MouseEvent<HTMLElement>, link: any): void => {
		e.preventDefault();
		setDidClickedScroll(true);

		props.onClick?.(e, link);
	};

	const { items, affix, showInkInFixed } = props;
	const anchorStyles = cx({
		activateBall: didClickedScroll,
		disabled: props.disabled
	});

	return (
		<Anchor
			className={anchorStyles}
			affix={affix}
			showInkInFixed={showInkInFixed}
			onClick={onClick}
			getContainer={props.getContainer}
			onChange={props.onChange}
			getCurrentAnchor={props.getCurrentAnchor}
			items={items}
			targetOffset={props.targetOffset}
			direction={props.direction}
		/>
	);
};

export default BCAnchor;
export { AnchorLinkItems as IAnchorLinkItemProps, IAnchorProps, IAnchorsItem, IAnchorState };
